import React from 'react'
import { observer, inject } from 'mobx-react'
import CONFIG from 'core/globals'
import { FREE_CHAT_WINDOW_DISCOUNT, freeChatWindowDiscountMinutesLeft } from 'core/freeChatWindow'
import { openUpgrade } from 'core/openUpgrade'

const popups = {
  delete: c => ({
    message: `Delete conversation with ${c.otherUserProfile.username}?`,
    primary: {
      text: 'OK',
      action: () => {
        c.markAsDeleted()
        sessionStorage.clear() // HACK - otherwise replay events adds back newly started + deleted conversations
      },
    },
  }),
  // AVN-1396: shown once the free chat window runs out. Side C carries the discount that dating puts on the
  // default ("best deal") product for fifteen minutes after the window, so the two have to say the same thing - and
  // once that has run out, side C is back to the standard offer.
  freeChatWindowExpired: (c, store) => {
    const discountMinutes = store && store.freeChatWindowHasDiscount
      ? freeChatWindowDiscountMinutesLeft(store.freeChatWindowDiscountEndsAt, store.now)
      : 0
    // Same routing as UpgradeLink: the Nuxt hook, the upgrade popup where a site uses one, or the upgrade page.
    const goToUpgrade = () => openUpgrade(CONFIG.urls.upgrade(c && c.otherUserProfile), CONFIG)
    const username = c && c.otherUserProfile && c.otherUserProfile.username

    // Side B, and side C once its discount has run out: the design's "that's a wrap" sheet.
    if (discountMinutes <= 0) {
      return {
        modifier: 'ccp-popup-modal--sheet',
        body: (
          <div className="fcw-wrap">
            <div className="fcw-wrap__ring">0:00</div>
            <div className="fcw-wrap__title">And{'\u2026'} that{'\u2019'}s a wrap</div>
            <p className="fcw-wrap__text">
              {username ? `Your free minutes with ${username} are up.` : 'Your free minutes are up.'} Top up to pick up
              right where the sparks were flying.
            </p>
          </div>
        ),
        primary: { text: 'Keep talking \u2014 get credits', action: goToUpgrade },
        secondary: 'Not now',
      }
    }

    // The card asks for side C to carry its own layout rather than side B's wording with a discount bolted
    // on, so the offer gets a panel of its own: the saving leads, and the time left on it is visible instead
    // of buried in a sentence. It ticks down because `store.now` is observable.
    return {
      modifier: 'ccp-popup-modal--offer',
      body: (
        <div className="fcw-offer">
          <div className="fcw-offer__badge">{`${FREE_CHAT_WINDOW_DISCOUNT}% OFF`}</div>
          <div className="fcw-offer__title">Your free chat window is over</div>
          <p className="fcw-offer__text">
            Keep the conversation going - take {FREE_CHAT_WINDOW_DISCOUNT}% off our best credit deal.
          </p>
          <div className="fcw-offer__timer">
            <span className="fcw-offer__timer-label">Offer ends in</span>
            <span className="fcw-offer__timer-value">
              {discountMinutes} {discountMinutes === 1 ? 'minute' : 'minutes'}
            </span>
          </div>
        </div>
      ),
      primary: { text: `Get ${FREE_CHAT_WINDOW_DISCOUNT}% Off Now`, action: goToUpgrade },
    }
  },
}

@inject('store')
@observer
class Popup extends React.Component {

  close = () => {
    this.props.store.popupType = null
  }

  action = f => () => {
    f()
    this.close()
  }

  render() {
    const { conversation, popupType } = this.props.store
    const { message, body, modifier, primary, secondary = 'Cancel' } = popups[popupType || 'delete'](conversation, this.props.store)

    return (
      <div className="ccp-popup">
        <div className="ccp-popup-overlay" onClick={this.close}></div>
        <div className={modifier ? `ccp-popup-modal ${modifier}` : 'ccp-popup-modal'}>
          {body || <div className="message">{message}</div>}
          <div className="actions">
            <button className="primary cta" onClick={this.action(primary.action)}>{primary.text}</button>
            <button className="secondary" onClick={this.close}>{secondary}</button>
          </div>
        </div>
      </div>
    )
  }
}

export default Popup
